/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPaymentCancel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M23.707 17.707 21.414 20l2.293 2.293-1.414 1.414L20 21.414l-2.293 2.293-1.414-1.414L18.586 20l-2.293-2.293 1.414-1.414L20 18.586l2.293-2.293z" />
        <path d="M24 14h-2V5H2v14h12v2H0V3h24z" />
        <path d="M13 7h3v2h-3v2h1a3 3 0 0 1 3 3h-2a1 1 0 0 0-1-1h-1v2h1v2h-1v1h-2v-1H8v-2h3v-2h-1a3 3 0 1 1 0-6h1V6h2zm-3 2a1 1 0 0 0 0 2h1V9z" />
      </g>
    </g>
  </Icon>
);
export { SvgPaymentCancel as PaymentCancel };
